import React from 'react'
import { last } from 'lodash'
import { Activity, ActivityStatus } from './types'
import { formatDate } from '@awell/ui-kit/utils'

interface Props {
  activity: Activity
}

export const ContextTab: React.FC<Props> = ({ activity }) => {
  const { track, container_name: stepName, date: activityStartDate, sub_activities, reference_type } = activity

  const activityCompletedDate = last(sub_activities)?.date ?? activity.date

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col gap-2">
        <div className="text-lg font-medium text-gray-900">Details</div>
        <div className="text-base text-gray-500">Useful contextual information about this activity</div>
      </div>
      <div key="track" className="rounded-xl border p-3">
        <div className="flex flex-col gap-2">
          <div className="text-sm font-medium text-gray-900">Track</div>
          <div className="text-sm text-gray-800 bg-slate-50 p-2 border border-slate-200 wrap-break-word">
            <p className="break-all">{track?.title ?? 'Unknown track'}</p>
          </div>
        </div>
      </div>
      {stepName && reference_type !== 'AGENT' && (
        <div key="step" className="rounded-xl border p-3">
          <div className="flex flex-col gap-2">
            <div className="text-sm font-medium text-gray-900">Step</div>
            <div className="text-sm text-gray-800 bg-slate-50 p-2 border border-slate-200 wrap-break-word">
              <p className="break-all">{stepName ?? 'Unknown step'}</p>
            </div>
          </div>
        </div>
      )}
      <div key="activated_on" className="rounded-xl border p-3">
        <div className="flex flex-col gap-2">
          <div className="text-sm font-medium text-gray-900">Activated on</div>
          <div className="text-sm text-gray-800 bg-slate-50 p-2 border border-slate-200 wrap-break-word">
            <p className="break-all">
              {formatDate({
                isoDateStr: activityStartDate,
                dateFormat: 'dd MMM yyyy, h:mm:ss a'
              })}
            </p>
          </div>
        </div>
      </div>
      <div key="completed_on" className="rounded-xl border p-3">
        <div className="flex flex-col gap-2">
          <div className="text-sm font-medium text-gray-900">Completed on</div>
          <div className="text-sm text-gray-800 bg-slate-50 p-2 border border-slate-200">
            {activity.status === ActivityStatus.Done
              ? formatDate({
                  isoDateStr: activityCompletedDate,
                  dateFormat: 'dd MMM yyyy, h:mm:ss a'
                })
              : 'Not completed'}
          </div>
        </div>
      </div>
    </div>
  )
}
